export const user_manual_permissions ={
    required_permission:['view_survey','view_response','add_response','change_response','view_answer','view_choice'],
    comparison_permission:['view_employee','view_responsecomparerequest','add_responsecomparerequest','change_responsecomparerequest','delete_responsecomparerequest']
}